import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { Close as CloseIcon, Rocket as RocketIcon, Timer as TimerIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';

/**
 * Banner que aparece en la parte superior del HomePage cuando:
 * - El trial está por vencer (< 7 días)
 * - El plan venció
 * - Está suspendido
 *
 * Se puede cerrar temporalmente (vuelve en la próxima sesión)
 */
export default function BannerUpgrade() {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const res = await axios.get(`${config.API_BASE_URL}/api/v1/suscripciones/mi-plan`);
        if (res.data?.success) setData(res.data.data);
      } catch (e) {
        // Silencioso
      }
    };
    fetchPlan();
  }, []);

  if (dismissed || !data) return null;

  const { suscripcion, plan } = data;
  const { estado, dias_restantes } = suscripcion;

  // No mostrar si todo está bien
  if (estado === 'ACTIVA') return null;
  if (estado === 'TRIAL' && dias_restantes > 7) return null;

  const esVencido = estado === 'VENCIDA' || estado === 'SUSPENDIDA';
  const esPorVencer = estado === 'TRIAL' && dias_restantes <= 7;

  if (!esVencido && !esPorVencer) return null;

  const bgColor = esVencido ? '#FEF2F2' : '#FFF7ED';
  const borderColor = esVencido ? '#FECACA' : '#FED7AA';
  const textColor = esVencido ? '#991B1B' : '#92400E';
  const Icon = esVencido ? RocketIcon : TimerIcon;

  return (
    <Box sx={{
      bgcolor: bgColor,
      border: `1px solid ${borderColor}`,
      borderRadius: 2,
      p: 1.5,
      mx: 2,
      mt: 1,
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
    }}>
      <Icon sx={{ color: textColor, fontSize: 24 }} />
      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" fontWeight={700} color={textColor}>
          {esVencido
            ? 'Tu plan ha vencido — no puedes crear nuevos servicios'
            : `Te quedan ${dias_restantes} días de prueba gratuita`}
        </Typography>
        <Typography variant="caption" color={textColor} sx={{ opacity: 0.8 }}>
          {esVencido
            ? 'Elige un plan para continuar usando TRACKEA'
            : 'Elige un plan antes de que termine tu período de prueba'}
        </Typography>
      </Box>
      <Button
        variant="contained"
        size="small"
        onClick={() => navigate('/home/suscripcion')}
        sx={{
          bgcolor: '#1E2783',
          '&:hover': { bgcolor: '#141A5C' },
          borderRadius: 2,
          fontWeight: 700,
          textTransform: 'none',
          whiteSpace: 'nowrap',
        }}
      >
        Ver planes
      </Button>
      <IconButton size="small" onClick={() => setDismissed(true)}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
